'use strict';

const _=require('pulsar-utils/dist-es6/_');
const{DataSet,Timeline}=require('vis-timeline');
const fastdom=require('fastdom');
const Formatters=require('../../../../dist-es6/client/formatters');
const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');let

ScheduleRowDirective=class ScheduleRowDirective extends BaseControllerBackedDirective{
get template(){return''}

get objectBindings(){return['schedule']}

get $inject(){return['$scope','$timeout','$element','$animate','timeZoneService','scheduleRowScrollingService']}

get controller(){return ScheduleRowController}};


const ControllerDefaults={
schedule:null,
_initialDrawComplete:!1};


const _windowUpdateOptions={
animation:!1};


const _timelineOptions={
autoResize:!0,
selectable:!1,
stack:!1,
zoomable:!1,
moveable:!1,
horizontalScroll:!1,
verticalScroll:!1,
showMajorLabels:!1,
showMinorLabels:!1,
tooltip:{
followMouse:!1,
overflowMethod:'flip',
delay:35},

margin:{
item:0},

start:new Date(new Date().getTime()-8.64e7*3),
end:new Date(new Date().getTime()+8.64e7*3)};let













ScheduleRowController=class ScheduleRowController{
constructor($scope,$timeout,$element,$animate,timeZoneService,scheduleRowScrollingService){
this._$scope=$scope;
this._$timeout=$timeout;
this._$element=$element;
$animate.enabled(!1,$element);

this._timeZoneService=timeZoneService;
this._scheduleRowScrollingService=scheduleRowScrollingService;

this._container=this._$element;
this._dataset=new DataSet;

_.defaults(this,ControllerDefaults);

this._momentWithTimeZoneForTimeline=date=>moment(date).tz(this.timeZone);
this.momentWithTimeZoneForTimeline=this._momentWithTimeZoneForTimeline.bind(this);

this._takeoffTimeFormatter=takeoffTime=>Formatters.timeInLocale(takeoffTime,this.timeZone,!0,!0);

this._$scope.$on('$destroy',()=>_.attempt(()=>this._timeline.destroy()));
this._setupWatchers();

this._debouncedUpdateData=_.debounce(()=>this._updateData(),150);

this._debouncedClearTooltip=_.debounce(()=>{
fastdom.measure(()=>{
const tooltipEl=this._container.find('.vis-tooltip');
const visibility=tooltipEl.css('visibility');
if(!tooltipEl||tooltipEl.length===0||!visibility||visibility==='hidden'){
return;
}

fastdom.mutate(()=>{
tooltipEl.css('visibility','hidden');
});
});
},1000);
}

async _redraw(){
if(!_.exists(this._timeline)){
this._setupTimeline();
}

this._updateWindow();

this._debouncedUpdateData();
this._debouncedClearTooltip();
}

_setupWatchers(){
this._$scope.$watch('controller.schedule',(newVal,oldVal)=>this._redraw());
this._$scope.$on('$destroy',()=>_.attempt(()=>this._scheduleRowScrollingService.unregisterScheduleRowDirective(this)));
this._scheduleRowScrollingService.registerScheduleRowDirective(this);
}

_setupTimeline(){
const timelineOptions=_.defaults({},{
moment:this._momentWithTimeZoneForTimeline,
onInitialDrawComplete:()=>this._initialDrawComplete=!0,
orientation:{
axis:'none',
item:'top'}},

this.currentBounds||{},_timelineOptions);

this._timeline=new Timeline(this._container[0],this._dataset,timelineOptions);

this._trySetupRangeChangeHandler();
}

_trySetupRangeChangeHandler(){
if(!this.rangeChangeHandler){
return;
}

this._isChangingRange=!1;
this._debouncedToggleRangeChangingStateHandler=_.debounce(()=>{this._isChangingRange=!1},75);
this._updateRangeChangingState=({byUser}={})=>{
if(!byUser){
return;
}

this._isChangingRange=!0;
this._debouncedToggleRangeChangingStateHandler();
};


this._timeline.on('rangechanged',(...args)=>{
this._updateRangeChangingState(...args);
return this.rangeChangeHandler(...args);
});

this._timeline.on('rangechange',(...args)=>this._updateRangeChangingState(...args));
}

_updateWindow(newBounds=this.currentBounds,options=_windowUpdateOptions){
if(!_.exists(newBounds)||!_.exists(this._timeline)){
return;
}

const{start:currentStart,end:currentEnd}=this._timeline.getWindow();
if(currentStart.getTime()===newBounds.start.getTime()&&currentEnd.getTime()===newBounds.end.getTime()){
return;
}

this._timeline.setWindow(newBounds.start,newBounds.end,options);
}

_getTimelineOptions(){
return _timelineOptions;
}

_updateOptions(newOptions){
_.merge(this._getTimelineOptions(),newOptions);

if(!this._timeline){
return;
}

this._timeline.setOptions(newOptions);
}

_updateData(){
if(!this.schedule){
return;
}

let takeoff;
if(this.schedule.takeoff){
takeoff={
id:'takeoff',
start:this.schedule.takeoff.time,
content:_.toString(Math.floor(this.schedule.takeoff.fatigue)),
type:'point',
title:`Fatigue at ${this._takeoffTimeFormatter(this.schedule.takeoff.time)}`,
className:`takeoff ${this.schedule.takeoff.thresholdStatus}`.trim()};

}

let scenarioBounds;
if(_.exists(this.schedule.scenario)&&this.schedule.scenario.trips&&this.schedule.scenario.trips.length!==0){
scenarioBounds={
id:'scenario-bounds',
start:_.first(this.schedule.scenario.trips).start,
end:_.last(this.schedule.scenario.trips).end,
className:_.compact([
`scenario-bounds`,
!_.exists(this.schedule.selectedFlightIndex)?'surround-pairing':null]).
join(' ')};

}

const flights=[];
if(this.schedule.trips){
this.schedule.trips.forEach((trip,index)=>{
const inScenario=!_.exists(trip.tod.thresholdStatus.original);
flights.push({
id:`filght-${index}`,
start:trip.start,
end:trip.end,
title:_formatTripLabel(trip),
className:_.compact([
`flight`,
trip.tod.thresholdStatus.scenario||trip.tod.thresholdStatus.original,
inScenario&&_.exists(this.schedule.selectedFlightIndex)&&index===this.schedule.selectedFlightIndex?'in-scenario':null]).
join(' ')});

});
}

const timeZone=this.timeZone;
const duties=[];
if(this.schedule.duties){
this.schedule.duties.forEach((duty,index)=>{
duties.push({
id:`duty-${index}`,
start:duty.start,
end:duty.end,
title:_formatDutyLabel(duty,timeZone),
className:_.compact([
`duty`,
duty.peak.scenario?duty.peak.scenario.thresholdStatus:duty.peak.original.thresholdStatus]).
join(' ')});

});
}

const newData=_.compact([scenarioBounds,...flights,...duties,takeoff]);

this._timeline.setItems(newData);
}

get currentBounds(){
return this._scheduleRowScrollingService.axisBounds;
}

get timeZone(){
return this.timeZoneOverride||this._timeZoneService.localTimeZone;
}

static get DefaultTimelineOptions(){
return _timelineOptions;
}};


function _formatTime(trip,key){
return Formatters.
formatInLocale(trip[key],`${Formatters.TwentyFourHourFormat} (Z)`,trip[key+'Timezone']).
replace(':00)',')');
}

function _formatDutyTime(duty,key,localTimeZone){
return Formatters.timeInLocale(duty[key],localTimeZone,!1,!0);
}

function _formatFatigueForTooltip(thing,fatiguePath,statusPath){
const flooredFatigue=_.toString(Math.floor(_.get(thing,fatiguePath)));
const statusClass=_.get(thing,statusPath);
if(statusClass==='below-threshold'){
return flooredFatigue;
}

return`<strong class="alerting-fatigue ${statusClass}">${flooredFatigue}</strong>`;
}

function _formatFatigueForTripTooltip(trip,kind){
return _formatFatigueForTooltip(trip,`tod.fatigue.${kind}`,`tod.thresholdStatus.${kind}`);
}

function _formatFatigueForDutyTooltip(duty,kind){
return _formatFatigueForTooltip(duty,`peak.${kind}.fatigue`,`peak.${kind}.thresholdStatus`);
}

function _formatTripLabel(trip){
const placesAndTimes=`${trip.origin.description} to ${trip.destination.description}<br/>${_formatTime(trip,'start')} - ${_formatTime(trip,'end')}`;
if(!_.exists(trip,'metadata.flight')){
return placesAndTimes;
}

let tripInfo=`<b>${trip.metadata.flight.code} ${trip.metadata.flight.number}</b><br/>${placesAndTimes}<div class="fatigue-break"></div>`;

if(_.exists(trip.tod.fatigue.original)&&!_.exists(trip.tod.fatigue.scenario)){
tripInfo+=`TOD Fatigue: ${_formatFatigueForTripTooltip(trip,'original')}`;
}

if(_.exists(trip.tod.fatigue.scenario)){
tripInfo+=`TOD Fatigue: ${_formatFatigueForTripTooltip(trip,'scenario')}`;

if(_.exists(trip.tod.fatigue.original)&&
Math.floor(trip.tod.fatigue.scenario)!==Math.floor(trip.tod.fatigue.original)){

tripInfo+=` (was ${_formatFatigueForTripTooltip(trip,'original')})`;
}
}

return tripInfo;
}

function _formatDutyLabel(duty,localTimeZone){
let dutyInfo=`<b>${duty.metadata.activity.code}</b><br/>${_formatDutyTime(duty,'start',localTimeZone)} - ${_formatDutyTime(duty,'end',localTimeZone)}<div class="fatigue-break"></div>`;

if(_.exists(duty.peak.original)&&!_.exists(duty.peak.scenario)){
dutyInfo+=`Peak Fatigue: ${_formatFatigueForDutyTooltip(duty,'original')}`;
}

if(_.exists(duty.peak.scenario)){
dutyInfo+=`Peak Fatigue: ${_formatFatigueForDutyTooltip(duty,'scenario')}`;

if(_.exists(duty.peak.original)&&
Math.floor(duty.peak.scenario.fatigue)!==Math.floor(duty.peak.original.fatigue)){

dutyInfo+=` (was ${_formatFatigueForDutyTooltip(duty,'original')})`;
}
}

return dutyInfo;
}

module.exports=ScheduleRowDirective;
module.exports.ScheduleRowDirectiveController=ScheduleRowController;
//# sourceMappingURL=scheduleRowDirective.js.map
